import type { WorkspaceType } from '@/features/workspaces/constants';

interface Props extends React.ComponentProps<'svg'> {
  type: WorkspaceType;
}

export function WorkspaceTypeIcon({ type, ...props }: Props) {
  if ('contract' === type)
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.25 12.8307C5.45991 12.8307 6.2363 12.4764 7.02882 11.7678M7.02882 11.7678C7.70455 11.1635 8.39201 10.3015 8.75 9.18207C9.52776 6.74963 4.86111 9.18207 6.41667 11.2091C6.60806 11.4585 6.81421 11.6408 7.02882 11.7678ZM7.02882 11.7678C7.96373 12.3208 9.05981 11.8239 9.80239 11.2524C10.0294 11.0778 10.1428 10.9905 10.2105 11.0176C10.2783 11.0448 10.3179 11.2011 10.3971 11.5137C10.6506 12.5139 11.3992 13.3213 12.25 12.0202"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6667 7.58073V4.60032C11.6667 3.60028 11.6667 3.10026 11.5103 2.70091C11.2591 2.05889 10.7276 1.55248 10.0539 1.31302C9.6348 1.16406 9.11009 1.16406 8.06062 1.16406C6.22405 1.16406 5.30578 1.16406 4.57238 1.42473C3.39333 1.84378 2.46331 2.73001 2.02355 3.85353C1.75 4.55241 1.75 5.42744 1.75 7.17753V8.68084C1.75 10.4937 1.75 11.4 2.24449 12.0295C2.38617 12.2098 2.5542 12.37 2.74346 12.505C2.95759 12.6577 3.20227 12.761 3.5 12.8307"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.75 6.9974C1.75 5.92348 2.62056 5.05295 3.69444 5.05295C4.08282 5.05295 4.54069 5.12101 4.9183 5.01983C5.2538 4.92992 5.51586 4.66787 5.60576 4.33236C5.70694 3.95475 5.63889 3.49688 5.63889 3.10851C5.63889 2.03462 6.50948 1.16406 7.58333 1.16406"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

  if ('tenderPackage' === type)
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.5211 6.41406V5.83073C11.5211 3.63084 11.5211 2.5309 10.8377 1.84748C10.1543 1.16406 9.05434 1.16406 6.85447 1.16406H6.27119C4.07131 1.16406 2.97138 1.16406 2.28796 1.84747C1.60454 2.53088 1.60453 3.63082 1.60452 5.83069L1.60449 8.16406C1.60447 10.3639 1.60447 11.4639 2.28786 12.1473C2.97128 12.8307 4.07126 12.8307 6.27114 12.8307"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.22949 4.08594H8.89614M4.22949 7.0026H8.89614"
          stroke="currentColor"
          strokeLinecap="round"
        />
        <path
          d="M7.72949 12.1464V12.8307H8.41398C8.65279 12.8307 8.7722 12.8307 8.87953 12.7863C8.98693 12.7418 9.07133 12.6574 9.24021 12.4885L12.054 9.67455C12.2132 9.5153 12.2928 9.43567 12.3354 9.3498C12.4165 9.18635 12.4165 8.9945 12.3354 8.83105C12.2928 8.74512 12.2132 8.6655 12.054 8.50625C11.8947 8.347 11.815 8.26737 11.7291 8.22479C11.5657 8.14382 11.3738 8.14382 11.2103 8.22479C11.1244 8.26737 11.0448 8.347 10.8855 8.50625L8.07173 11.3202C7.90292 11.4891 7.81845 11.5735 7.774 11.6808C7.72949 11.7882 7.72949 11.9075 7.72949 12.1464Z"
          stroke="currentColor"
          strokeLinejoin="round"
        />
      </svg>
    );

  return null;
}
